import type { JSX } from 'react';

/**
 * AdminDashboardPage — stub with navigation links to portal features.
 */
export function AdminDashboardPage(): JSX.Element {
  return (
    <div className="p-8">
      <h1 className="text-2xl font-semibold text-gray-900">Admin Dashboard</h1>
      <nav className="mt-4 space-y-2">
        <a
          href="/referral-queue/unknown-provider"
          className="block w-fit rounded border border-blue-200 bg-blue-50 px-4 py-2 text-sm font-medium text-blue-800 hover:bg-blue-100"
        >
          Unknown Provider Review Queue
        </a>
      </nav>
    </div>
  );
}
